import MarkdownPage from "@/lib/pages/MarkdownPage";
import {useLocalSearchParams} from "expo-router";

export default function Index() {
    const {slug} = useLocalSearchParams();

    return (
        <MarkdownPage slug={slug.toString()}/>
    )
}